import { compose, apply, divide, juxt, prop } from 'ramda';

export const sectionAccessor = id => `background.sections.${id}`;

export const labelAccessor = id => `background.labels.${id}`;

export const optionAccessor = id => `background.opts.${id}`;

export const valueExists = value => {
  if (value || value === 0) {
    if (typeof value === 'string' || Array.isArray(value)) return value.length > 0;
    return true;
  }
  return false;
};

// Used to compute the patient's BMI. Returns a function that takes the formValues as an argument
export const computeBMI = compose(
  x => Math.floor(x * 100) / 100,
  apply(divide),
  juxt([prop('patientWeight'), compose(x => Math.pow(x, 2) / 10000, prop('patientLength'))]),
);
